import { TimerIcon } from './TimerIcon';

/**
 * author: Michael Irigoyen
 * id 7F6AFDDE-8C90-44FB-A000-D5F6EF93A943
 * name timer
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer.svg
 * tags
 * - Sport 
 * - Date / Time 
 */
export const StopwatchIcon = TimerIcon;
export default StopwatchIcon